const homePaths = {
  commercial: '/commercial',
  home: '/home',
  hub: '/hub',
  login: '/login',
  new: '/new',
  personal: '/personal',
  tasks: '/tasks',
};

export default homePaths;
